// extracted by css-extract-rspack-plugin
export default {"core-upsell":"IYckOu","coreUpsell":"IYckOu","core-upsell-text":"KmELJq","coreUpsellText":"KmELJq","core-cta":"k5HSOy","coreCta":"k5HSOy"};